import { Col, Row, Typography } from "antd";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form } from "formik-antd";
import React from "react";
import { FormikEmailInput, FormikSubmitButton } from "../FormItems";
import { MailOutlined } from "@ant-design/icons";
import Feedback from "../Utilities/Feedback";
import { connect } from "react-redux";
import * as userReducer from "../Redux/User/reducer";
import constants from "../Redux/constants";

const initialValues = {
  email: "",
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
});

const ForgotPasswordForm = (props) => {
  const sendResetLink = (formValues, actions) => {
    props.forgotPassword(formValues.email).then((response) => {
      if (response === constants.status.notFound) {
        actions.setErrors({ email: "No such user found!!" });
        actions.setSubmitting(false)
      }
    });
  };
  return (
    <Col xs={{ span: 24 }} style={{ overflowX: "hidden" }}>
      {props.isEmailSent ? (
        <Col xs={{ span: 24 }}>
          <Feedback
            icon={<MailOutlined />}
            title="Mail Sent"
            subTitle="A reset password link has been sent to your mail"
          ></Feedback>
        </Col>
      ) : (
        <Col
        xs={{ span: 22 }}
        md={{ span: 14 }}
        lg={{ span: 12 }}
        xl={{ span: 8 }}
        xxl={{ span: 8 }}
        style={{ margin: "auto", marginTop: "2vh" }}
        >
          <Row>
            <Typography.Title level={4}>Reset Password</Typography.Title>
          </Row>
          <Row>
            <Typography.Paragraph>
              You will get an email to change your password
            </Typography.Paragraph>
          </Row>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={sendResetLink}
              validateOnMount
            >
              {(formik) => {
                return (
                  <Form>
                    <Col xl={{ span: 20 }}>
                      <FormikEmailInput name="email" prefix={false} />
                    </Col>
                    <Col xl={{ span: 20 }} md={{ span: 20 }}>
                      <FormikSubmitButton
                        disabled={!formik.isValid}
                        name="Send Email"
                      ></FormikSubmitButton>
                    </Col>
                  </Form>
                );
              }}
            </Formik>
        </Col>
      )}
    </Col>
  );
};

const mapToState = (state) => ({
  isEmailSent: state.userStore.isEmailSent,
});

const mapToReducer = (dispatch) => {
  return {
    forgotPassword: (email) => dispatch(userReducer.forgotPassword(email)),
  };
};

export default connect(mapToState, mapToReducer)(ForgotPasswordForm);
